<div class="topbar">
  <div class="left">
    <ui-pr-env-picker />
    <ui-logo [small]="true" />
  </div>
  <div class="center">
    <h3>NotificationService DEMO</h3>
  </div>
  <div class="right">
    <ns-notifications-component
      (newNotificationReceived)="handleNewNotification($event)" />
  </div>
</div>
<section>
  <div class="test-notification">
    <test-trigger />
  </div>
</section>
